var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoblet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41,
    height: 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_116450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6706 27.5351L23.555 27.5142L22.4846 7.95716L22.414 6.68455L21.9729 3.46875L19.0028 3.48067L18.6646 6.69945L18.6028 7.97206L17.6706 27.5351Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77026 3.08736C3.7732 4.35401 3.9173 5.59086 4.18196 6.78002C5.87582 14.3561 12.563 19.9979 20.547 19.9711C29.7809 19.9353 37.2356 12.3265 37.2032 2.96815C37.2032 2.60455 37.1885 2.24094 37.165 1.8833L3.80261 2.0055C3.78203 2.36314 3.77026 2.72674 3.7732 3.09034L3.77026 3.08736Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55713 3.07524C7.56301 4.98267 7.97471 6.79472 8.70695 8.42795C10.7449 12.9849 15.2824 16.153 20.5316 16.1351C27.6628 16.1083 33.4413 10.2072 33.4178 2.98285C33.4178 2.61626 33.4001 2.25266 33.3707 1.89502L7.5983 1.99039C7.56889 2.34803 7.55713 2.71164 7.55713 3.07822V3.07524Z",
    fill: "#456EBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9009 17.471C33.3564 17.471 35.4178 16.7795 37.0558 15.4026C40.6876 12.3507 40.7788 7.09038 40.7817 6.86984L40.7935 5.7373L34.9561 5.75817L34.965 7.99343L38.4674 7.98151C38.2468 9.46274 37.591 12.0557 35.6384 13.6889C33.9416 15.1075 31.5508 15.5516 28.5277 15.0062L28.1425 17.2087C29.11 17.3845 30.0304 17.471 30.9009 17.471Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8802 17.5453C10.7801 17.5453 11.7299 17.4499 12.7327 17.2622L12.3298 15.0627C9.31265 15.6289 6.91891 15.2027 5.21035 13.796C3.24889 12.1777 2.57253 9.58775 2.34315 8.10949L5.84555 8.09757L5.83672 5.8623L-0.000594139 5.88317L0.0199938 7.0157C0.022934 7.23923 0.155266 12.4966 3.80763 15.5216C5.43385 16.8687 7.47176 17.5453 9.88314 17.5453H9.8802Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1209 28.066C16.1209 28.6233 16.5679 29.0763 17.1178 29.0763H24.1108C24.6607 29.0763 25.1077 28.6233 25.1077 28.066C25.1077 27.5087 24.6607 27.0557 24.1108 27.0557H17.1178C16.5679 27.0557 16.1209 27.5087 16.1209 28.066Z",
    fill: "#1F50B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M3.82282 2.0293H27.9367C28.6719 10.6723 16.9402 19.4235 8.96907 15.2919C6.76354 13.0566 3.45502 8.56378 3.82282 2.0293Z",
    fill: "#7199E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2302 10.1563C13.9892 8.90092 12.6458 8.05959 11.7425 8.6277C10.8467 9.17848 10.7316 10.9267 11.9728 12.182C13.202 13.4477 15.2674 13.6636 16.1588 13.1059C17.0664 12.5448 16.4596 11.4218 15.2302 10.1563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5454 4.42053C13.1702 3.662 12.4729 3.49623 11.8586 4.11666C11.2468 4.73461 10.9501 5.90443 11.3253 6.66291C11.6973 7.42321 12.5918 7.47752 13.2029 6.85887C13.818 6.23894 13.9173 5.18083 13.5454 4.42053Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_116450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.7936,
    height: 28.167,
    fill: "white",
    transform: "matrix(-1 0 0 1 40.7935 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoblet);
export default __webpack_public_path__ + "static/media/goblet.2154f0acfff2e77cd308.svg";
export { ForwardRef as ReactComponent };